import { useEffect } from "react";
import { Button, message, Tabs, Drawer, Checkbox } from "antd";
import UiButton from "../../Common/UiButton/UiButton";
import { Col, Row } from "react-bootstrap";
import "./style.css";
import BranchDetailsTab from "./BranchDetailsTab";
import Verified from "../../../images/Verified-Partner.png";
import notVerified from "../../../images/notVerified.jpeg";
import FrimDetailsTabs from "./FrimDetailsTabs";
import TeamDetailsTabs from "./TeamDetailsTabs";
import { useLocation, useNavigate } from "react-router-dom";
import RCUManager from "./RCUManager";
import { connect } from "react-redux";
import { getAllEngagementDetails } from "../../../redux/EngagementDetails/EngagementDetailsAction";
import {
  getPartnerViewDetails,
  saveLeadActivation,
} from "../../../redux/EditPartner/EditPartnerAction";
import BankDetailsTabs from "./BankDetailsTabs";

import { useState } from "react";
import ProgressValueBox from "./ProgressValueBox";
import { EngagementDetailMaster } from "../../../redux/EngagementDetails/actions";
import PartnerPortalStatusBar from "../../PartnerPortalStatusBar/PartnerPortalStatusBar";
import { getDocuments } from "../../../redux/Documents/Get/GetDocumentsAction";
import { documentsMaster } from "../../../redux/Documents/Master/DocumentMasterAction";
import ViewDocuments from "./ViewDocuments";
import { getPartnerPanDocuments } from "../../../redux/viewPartnerDocuments/action";
import { getProgress } from "../../../redux/progressBar/action";
import CustomLogout from "../../CustomLogout/CustomLogout";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Modal, notification } from "antd";
import ESign from "./ESign";
import { getESignDetails } from "../../../redux/RcuInfoEditPartner/action";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import BranchPreferences from "../../BranchPreferences/BranchPreferences";
import useSession from "../../CustomLogout/useSession";
import { saveFirmPanDetails } from "../../../redux/FirmPanDetails/action";

const EditPartner = (props) => {
  const handleSessionExpired = useSession();

  const location = useLocation();
  const id = location?.state?.partnerFirmId;

  const history = useNavigate();
  const [pan, setPan] = useState("");
  const [loading, setLoading] = useState(true);

  const [save, setSave] = useState(false);

  const [teamPan, setTeamPan] = useState("");
  const [teamAddhar, setTeamAddhar] = useState("");
  const [leadDisabled, setLeadDisabled] = useState(false);
  const [bank, setBank] = useState("");
  const [gst, setGst] = useState("");
  const [open, setOpen] = useState(false);
  const [leadActivation, setLeadActivation] = useState(false);
  const [show, setShow] = useState("");
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const [eSignGetData, setEsightGetData] = useState("");
  const [modelEsign, setModelEsign] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  const [disable, setDisable] = useState(false);
  const handleESignModelClose = () => {
    setIsActive(true);
    setActiveKey("7");
    setModelEsign(false);
  };

  useEffect(() => {
    getAllEngagementDetailsData();
    getPartnerViewDetailsData();
    props?.getAllDocuments({ partnerFirmId: id });
    props?.getAllDocumentsMaster({ partnerFirmId: id });
    props?.getProgress({ partnerFirmId: id });

    if (
      props?.state?.userData?.loggedInRoleType !== "PARTNER" &&
      props?.state?.userData?.loggedInRoleType !== "POU"
    ) {
      props
        .getESignDetails({
          access_token: props?.accessToken,
          partnerFirmId: id,
        })
        .then((res) => {
          if (res?.status === 200) {
            setEsightGetData(res?.data?.dto);
            const dataEsign = res?.data?.dto;
            if (dataEsign?.esignStatus === "COMPLETED") {
              setModelEsign(false);
            }
            if (res?.data?.error || res?.message) {
              const errorCode = res?.data?.error?.errorCode || res?.errorCode;
              const errorMessage = res?.data?.error?.message || res?.message;

              if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                handleSessionExpired();
              } else {
                notification.error({
                  description: errorMessage,
                  duration: 5,
                  placement: "top",
                });
              }
            }
          }
        });
    }

    if (
      props?.state?.userData?.loggedInRoleType === "RM" ||
      props?.state?.userData?.loggedInRoleType === "PARTNER" ||
      props?.state?.userData?.loggedInRoleType === "POU"
    ) {
      setModelEsign(false);
    }
  }, [id]);

  useEffect(() => {
    if (props?.DocData?.Pan?.dto?.response) {
      setPan(JSON.parse(props?.DocData?.Pan?.dto?.response));
    }
    if (props?.DocData?.Gst?.dto?.response) {
      setGst(JSON.parse(props?.DocData?.Gst?.dto?.response));
    }

    if (props?.DocData?.TeamPan?.dto?.response) {
      setTeamPan(JSON.parse(props?.DocData?.TeamPan?.dto?.response));
    }

    if (props?.DocData?.TeamAdd?.dto?.response) {
      setTeamAddhar(JSON.parse(props?.DocData?.TeamAdd?.dto?.response));
    }

    if (props?.DocData?.Bank?.dto?.response) {
      setBank(JSON.parse(props?.DocData?.Bank?.dto?.response));
    }
  }, [props?.DocData]);

  useEffect(() => {
    props?.getData(props?.accessToken);
    // props?.getPanDoc({ accessToken: props?.accessToken, firmId: id });
  }, []);

  useEffect(() => {
    if (save) {
      saveLead();
    }
  }, [leadActivation]);

  useEffect(() => {
    setLeadActivation(props?.editPartner?.dto?.leadActivationFlag);
  }, [props?.editPartner]);

  const saveLead = () => {
    setLeadDisabled(true);

    props
      .saveLeadActivation({
        access_token: props?.accessToken,
        firmId: id,
        leadActivation: leadActivation,
      })
      .then((res) => {
        getPartnerViewDetailsData();
        setLeadDisabled(false);
        setSave(false);
        if (res && res?.success?.status === 200) {
          getPartnerViewDetailsData();
        }
        if (res?.response?.data?.error || res?.response?.message) {
          const errorCode =
            res?.response?.data?.error?.errorCode || res?.response?.errorCode;
          const errorMessage =
            res?.response?.data?.error?.message || res?.response?.message;
          setLeadDisabled(false);
          setSave(false);
          if (errorCode === "403" && res?.response?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            setLeadDisabled(false);
            setSave(false);
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === "Enter") {
        handleESignModelClose();
      }
    };

    if (modelEsign) {
      window.addEventListener("keydown", handleEnterKeyPress);
    } else {
      window.removeEventListener("keydown", handleEnterKeyPress);
    }

    return () => {
      window.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [modelEsign]);

  const triggerPan = () => {
    setDisable(true);
    const panVerificationData = {
      partnerFirmPanNo: partnerFirmPanNo,
      partnerFirmPanConsentFlag: true,
    };
    props
      .saveFirmPanDetails({
        values: panVerificationData,
        access_token: props?.accessToken,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res && res?.status === 200) {
          setDisable(false);

          message.success("Pan Number Verified");
          getPartnerViewDetailsData();
        }
        if (res?.data?.error || res?.message) {
          const errorCode = res?.data?.error?.errorCode || res?.errorCode;
          const errorMessage = res?.data?.error?.message || res?.message;
          setDisable(true);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            setDisable(false);
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        } else {
          setDisable(false);
        }
      })
      .catch(() => {
        setDisable(false);
      });
  };

  const getAllEngagementDetailsData = () => {
    const user = {
      partnerFirmId: id,
      access_token: props?.accessToken,
    };
    props?.getAllEngagementDetails(user).then((res) => {
      if (res?.success.status === "200") {
      }
      if (res?.data?.error || res?.message) {
        const errorCode = res?.data?.error?.errorCode || res?.errorCode;
        const errorMessage = res?.data?.error?.message || res?.message;

        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
  };

  const getPartnerViewDetailsData = () => {
    const user = {
      partnerFirmId: id,
      access_token: props?.accessToken,
    };
    props
      .getPartnerViewDetails(user)
      .then((res) => {
        setLoading(false);
        if (res?.success.status === "200") {
        }
        if (res?.data?.error || res?.message) {
          const errorCode = res?.data?.error?.errorCode || res?.errorCode;
          const errorMessage = res?.data?.error?.message || res?.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            setLoading(false);

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const productDtoList =
    props?.engagementDetails?.Product?.dtoList?.length > 0
      ? props?.engagementDetails?.Product?.dtoList.filter((val) => {
          return val.active == true;
        })
      : [];

  const productDtoName = productDtoList.map((el) => {
    return props?.EngagementMaster?.partnerProductMasterList?.find((k) => {
      return el?.productId == k?.productId;
    });
  });

  const dto = props?.editPartner?.dto || {};

  const partnerPayoutDetails = {
    firstDisbursement: dto.firstDisbursement || "",
    trancheDisbursement: dto.trancheDisbursement || "",
    payoutEffectiveDate: dto.payoutEffectiveDate || "",
  };

  const roleDtoList =
    props?.engagementDetails?.Roles?.dtoList?.length > 0
      ? props?.engagementDetails?.Roles?.dtoList.filter((val) => {
          return val.active == true;
        })
      : [];

  const roleDtoName = roleDtoList.map((el) => {
    return props?.EngagementMaster.partnerFunctionMasterList.find((k) => {
      return el.functionTypeId == k.partnerFunctionId;
    });
  });

  const engagementDtoList =
    props?.engagementDetails?.Type?.dtoList?.length > 0
      ? props?.engagementDetails?.Type?.dtoList.filter((val) => {
          return val.active == true;
        })
      : [];

  const engagementDtoName = engagementDtoList.map((el) => {
    return props?.EngagementMaster.partnerTypeMasterList.find((k) => {
      return el.partnerTypeId == k.partnerTypeId;
    });
  });

  const branchDtoList =
    props?.editPartner?.PARTNER_BRANCH_MASTER_DTO_LIST?.length > 0
      ? props?.editPartner?.PARTNER_BRANCH_MASTER_DTO_LIST
      : [];

  const partnerCode = props?.editPartner?.dto?.partnerDisplayCode ?? "";

  const bankDetails =
    props?.editPartner?.PARTNER_FIRM_BANK_DETAILS_DTO?.dto ?? "";

  const partnerCompanyName =
    props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.partnerFirmName ?? "";

  const constitution =
    props?.editPartner?.PARTNER_FIRM_CONSTITUTION_DETAILS_DTO
      ?.partnerFirmCompanyType?.name ?? "";

  const natureOfBusiness =
    props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.natureOfBusiness ?? "";

  const countriesFocusedOn =
    props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.countriesFocusedOn?.length > 0
      ? props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.countriesFocusedOn
          ?.map((item) => item.name)
          .join(", ")
      : "";

  const noOfEmployees =
    props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.noOfEmployees?.name ?? "";

  const turnOverInLacs =
    props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.turnOverInLacs ?? "";

  const partnerFirmPanNo =
    props?.editPartner?.PARTNER_FIRM_PAN_DETAILS_DTO?.partnerFirmPanNo ?? "";

  const partnerFirmPanConsentFlag =
    props?.editPartner?.PARTNER_FIRM_PAN_DETAILS_DTO?.isPanVerified;

  const PanMatchFlag =
    props?.editPartner?.PARTNER_FIRM_PAN_DETAILS_DTO?.isPanMatchedWithName ??
    false;

  const partnerFirmMSMEFlag =
    props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.partnerFirmMSMEFlag ?? "";

  const saacCode = props?.editPartner?.PARTNER_FIRM_DETAIL_DTO?.saacCode ?? "";

  // const partnerTitle = productDtoName.map(el => {
  //   return (
  //     el?.productName
  //   )
  // }).join('|') + "," + " " + roleDtoName.map((el) => {
  //   return (
  //     el?.partnerFunctionName
  //   )

  // }).join("|")

  let PanAddress = `${pan?.result?.address?.buildingName ?? ""} ,${
    pan?.result?.address?.buildingName ?? ""
  } ,${pan?.result?.address?.locality ?? ""} ,${
    pan?.result?.address?.streetName ?? ""
  },${pan?.result?.address?.pinCode ?? ""}`;

  let TeamPanAddress = `${teamPan?.result?.address?.buildingName ?? ""} ,${
    teamPan?.result?.address?.buildingName ?? ""
  } ,${teamPan?.result?.address?.locality ?? ""} ,${
    teamPan?.result?.address?.streetName ?? ""
  },${teamPan?.result?.address?.pinCode ?? ""}`;

  let showfirmPan = () => {
    props
      .getPanDoc({ accessToken: props?.accessToken, firmId: id })
      .then((res) => {
        setShow("firmPan");
        showDrawer();
      });
  };

  const handleLeadActivation = () => {
    setLeadActivation((prev) => !prev);

    setSave(true);
  };

  useEffect(() => {
    if (
      props?.editPartner?.status == "CODE_CREATED" ||
      props?.editPartner?.status == "NEW_PARTNER"
    ) {
      setModelEsign(false);
    }
  }, [props?.editPartner?.status]);

  const approvedStatus =
    props?.editPartner?.status === "APPROVED" ? true : false;

  const NewPartnerStatus =
    props?.editPartner?.status === "NEW_PARTNER" ? true : false;

  const codeCreatedStatus =
    props?.editPartner?.status === "CODE_CREATED" ? true : false;

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin
          size="large"
          indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
        ></Spin>{" "}
      </div>
    );
  }

  const handleTabsChange = (key) => {
    setActiveKey(key);
  };

  return (
    <div>
      <Modal
        open={modelEsign}
        keyboard={true}
        closable={true}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col md={12} className="headre-login">
              <ModalHeaderText LoginHeading="E-Sign" />
            </Col>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={12}>
            <p>Your E-Sign is pending</p>
          </Col>
        </Row>
        <Row className="">
          <Col md={12} className="d-flex justify-content-end">
            <Button
              onClick={handleESignModelClose}
              className=""
              htmlType="text-btn-sec"
              type="primary"
            >
              Ok
            </Button>
          </Col>
        </Row>
      </Modal>

      {props?.LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
      <Drawer
        title="Response Info"
        placement="right"
        onClose={onClose}
        size={650}
        className="add-partner-dow"
        open={open}
      >
        <div className="addpartnerheading">
          <h2 className="main-heading">Response Info</h2>
          <div className="headre-line"></div>
        </div>
        {show === "firmPan" && (
          <>
            <div className="response-sub-text" style={{ display: "flex" }}>
              <b>Pan</b>:<p>{pan?.result?.pan}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Name</b>:<p>{pan?.result?.name}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>First Name</b>:<p>{pan?.result?.firstName}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Middle Name</b>:<p>{pan?.result?.middleName}</p>
            </div>

            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Last Name</b>:<p>{pan?.result?.lastName}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Gender</b>:<p>{pan?.result?.gender}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Date of Birth</b>:<p>{pan?.result?.dob}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Address</b>:<p>{PanAddress}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Aadhaar Linked</b>:
              <p>{pan?.result?.aadhaarLinked == true ? "true" : "false"}</p>
            </div>
          </>
        )}

        {show === "TeamPan" && (
          <>
            <div className="response-sub-text" style={{ display: "flex" }}>
              <b>Pan</b>:<p>{teamPan?.result?.pan}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Name</b>:<p>{teamPan?.result?.name}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>First Name</b>:<p>{teamPan?.result?.firstName}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Middle Name</b>:<p>{teamPan?.result?.middleName}</p>
            </div>

            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Last Name</b>:<p>{teamPan?.result?.lastName}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Gender</b>:<p>{teamPan?.result?.gender}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Date of Birth</b>:<p>{teamPan?.result?.dob}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Gender</b>:<p>{teamPan?.result?.gender}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Address</b>:<p>{TeamPanAddress}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Aadhaar Linked</b>:
              <p>{teamPan?.result?.aadhaarLinked == true ? "true" : "false"}</p>
            </div>
          </>
        )}
        {show === "BranchGST" && (
          <>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>GSTIN</b>:<p> {gst?.result?.gstin}</p>
            </div>

            <div
              style={{
                marginBottom: "2vh",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
              }}
            >
              <b>Contact Details:</b>
              {gst?.result?.contacted &&
                Object.keys(gst?.result?.contacted).length > 0 &&
                Object.keys(gst?.result?.contacted)?.map((obj) => {
                  return (
                    <div class="response-sub-text" style={{ display: "flex" }}>
                      <b>{obj}</b>:<p>{gst?.result?.contacted[obj]}</p>
                    </div>
                  );
                })}
            </div>

            <div
              style={{ marginBottom: "2vh", borderBottom: "1px solid black" }}
            >
              <b>Entity Profile:</b>
              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Legal Name of Bussiness</b>:<p>{gst?.result?.lgnm}</p>
              </div>
              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Trade Name</b>:<p>{gst?.result?.tradeNam}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Status</b>:<p>{gst?.result?.sts}</p>
              </div>
              {gst?.result?.mbr?.map((el, index) => {
                return (
                  <div class="response-sub-text" style={{ display: "flex" }}>
                    <b>{`Authorized Signatories${index + 1}`}</b>:<p>{el}</p>
                  </div>
                );
              })}

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Nature of Bussines</b>:<p>{gst?.result?.nba?.join(",")}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Tax payer type</b>:<p>{gst?.result?.dty}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>State Jurisdiction</b>:<p>{gst?.result?.stj}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <div>
                  {" "}
                  <b>Central Jurisdiction</b>
                </div>
                :
                <div>
                  <p>{gst?.result?.ctj}</p>
                </div>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Date of Registeration</b>:<p>{gst?.result?.rgdt}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Date of Cancellation</b>:<p>{gst?.result?.cxdt}</p>
              </div>
            </div>

            <div
              style={{ marginBottom: "2vh", borderBottom: "1px solid black" }}
            >
              <b>Primary Business Address</b>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Registered Address</b>:<p>{gst?.result?.pradr?.adr}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Last Updated Date</b>:
                <p>{gst?.result?.pradr?.lastUpdatedDate}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Email</b>:<p>{gst?.result?.pradr?.em}</p>
              </div>

              <div class="response-sub-text" style={{ display: "flex" }}>
                <b>Mobile Number</b>:<p>{gst?.result?.pradr?.mb}</p>
              </div>
            </div>

            {/* <div class="response-sub-text" style={{ display: "flex" }}>
                <b>ctb</b>:<p>{gst?.result?.ctb}</p>
              </div> */}
          </>
        )}
        {show == "TeamAddhar" && (
          <>
            {/* <b>Addhar</b> */}

            <div className="response-sub-text" style={{ display: "flex" }}>
              <b>Issued</b>:
              <p>{teamAddhar?.result?.isIssued == "Y" ? "Yes" : "No"}</p>
            </div>
          </>
        )}

        {show == "Bank" && (
          <>
            <div className="response-sub-text" style={{ display: "flex" }}>
              <b>Account Name</b>:
              <p>
                {bank?.result?.bankData?.source[0]?.sourceData?.accountName}
              </p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Account Number</b>:
              <p>
                {bank?.result?.bankData?.source[0]?.sourceData?.accountNumber}
              </p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>IFSC</b>:
              <p>{bank?.result?.bankData?.source[0]?.sourceData?.ifsc}</p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Bank Taxation Status</b>:
              <p>
                {bank?.result?.bankData?.source[0]?.sourceData?.bankTxnStatus ==
                true
                  ? "true"
                  : "false"}
              </p>
            </div>

            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Bank Response</b>:
              <p>
                {bank?.result?.bankData?.source[0]?.sourceData?.bankResponse}
              </p>
            </div>
            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Is Valid</b>:
              <p>
                {bank?.result?.bankData?.source[0]?.isValid == true
                  ? "true"
                  : "false"}
              </p>
            </div>

            <div class="response-sub-text" style={{ display: "flex" }}>
              <b>Status As Per Source</b>:
              <p>{bank?.result?.bankData?.source[0]?.statusAsPerSource}</p>
            </div>
          </>
        )}
      </Drawer>
      <div className="content-edit-partner">
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="newdisebar">
            <PartnerPortalStatusBar cet={true} />
          </Col>
        </Row>
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="tbtn-name-text-add">
            <Col md={4} className="">
              {props?.state?.userData?.loggedInRoleType === "RM" &&
                (NewPartnerStatus || codeCreatedStatus) && (
                  <UiButton
                    type="button"
                    title="Edit Partner"
                    onClick={() => {
                      sessionStorage.setItem("cetFirmId", id);

                      history(`/PartnerDashBoard/EngagementDetails`);
                    }}
                  />
                )}
            </Col>
            <Col md={8} className=""></Col>
          </Col>
        </Row>
        <Row>
          <Col
            lg={12}
            xs={12}
            md={12}
            sm={12}
            className="ineer-ed-text mob-sec-editviewtabs"
          >
            <Col md={4} className="">
              <div className="text-content-ed">
                <h3>{partnerCompanyName}</h3>
                <h4>
                  Partner - {partnerCode} <br></br>
                </h4>
              </div>
            </Col>
            <Col md={8} className="">
              <div className="progress-section-EP">
                {props?.progressData?.length > 0
                  ? props?.progressData?.map((item, index) => (
                      <ProgressValueBox item={item} index={index} />
                    ))
                  : ""}
              </div>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col
            lg={12}
            xs={12}
            md={12}
            sm={12}
            className="ineer-ed-text mob-sec-editviewtabs"
          >
            {(props?.state?.userData?.loggedInRoleType === "CET" ||
              props?.state?.userData?.loggedInRoleType === "RM") && (
              <Col md={4} className="">
                <div className="text-content-ed add-partner-checkbox mob-chk-d">
                  <h5>Activate Lead Management</h5>
                  <Checkbox
                    className="leadActivate"
                    value={leadActivation}
                    disabled={NewPartnerStatus}
                    onClick={() => handleLeadActivation()}
                    checked={leadActivation}
                  />
                </div>
              </Col>
            )}

            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>Constitution</h5>
                <h2>{constitution ? constitution : "------"}</h2>
              </div>
            </Col>
            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>Nature Of Business</h5>
                <h2>{natureOfBusiness ? natureOfBusiness : "------"}</h2>
              </div>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col
            lg={12}
            xs={12}
            md={12}
            sm={12}
            className="ineer-ed-text mob-sec-ec"
          >
            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>Countries Focused In</h5>
                <h2>{countriesFocusedOn ? countriesFocusedOn : "------"}</h2>
              </div>
            </Col>
            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>Employee Count</h5>
                <h2>{noOfEmployees ? noOfEmployees : "------"}</h2>
              </div>
            </Col>
            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>Turnover (Lacs)</h5>
                <h2>{turnOverInLacs ? turnOverInLacs : "------"}</h2>
              </div>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col
            lg={12}
            xs={12}
            md={12}
            sm={12}
            className="ineer-ed-text mob-sec-Pan"
          >
            <Col md={4} className="">
              <div className="text-content-ed ">
                <h5>Pan</h5>

                {partnerFirmPanConsentFlag ? (
                  <div className="pan-ver">
                    <h2>{partnerFirmPanNo} </h2>
                    <div className="sec-pan-verf">
                      <div>
                        <img src={Verified} alt="" />
                        {props?.state?.userData?.loggedInRoleType !==
                        "PARTNER" ? (
                          <>
                            <div
                              onClick={showfirmPan}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "2vw",
                              }}
                            >
                              <b
                                className="text-view"
                                style={{ color: "blue" }}
                              >
                                View Response
                              </b>
                            </div>
                            {PanMatchFlag ? (
                              <p
                                className="pan-match-text"
                                style={{ color: "green", marginLeft: "2vw" }}
                              >
                                Pan Matched with the name
                              </p>
                            ) : (
                              <p
                                className="pan-match-text-red"
                                style={{ color: "red" }}
                              >
                                Pan doesn't match with the name
                              </p>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                ) : partnerFirmPanNo ? (
                  <>
                    <p>{partnerFirmPanNo}</p>
                    <img className="notverified" src={notVerified} />
                    {props?.state?.userData?.loggedInRoleType === "CET" ? (
                      <div>
                        <UiButton
                          disable={disable}
                          onClick={triggerPan}
                          type="submit"
                          title="retrigger"
                        />
                        {disable && <Spin />}
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <b>No data</b>
                )}
              </div>
            </Col>
            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>MSME Registered</h5>
                <h2>{partnerFirmMSMEFlag ? "Yes" : "No"} </h2>
              </div>
            </Col>
            <Col md={4} className="">
              <div className="text-content-ed">
                <h5>SAAC Code</h5>
                <h2>{saacCode ? saacCode : "------"} </h2>
              </div>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="ineer-ed-text">
            <Col md={12} className="">
              <div className="tabs-section">
                <Tabs
                  activeKey={isActive ? activeKey : "1"}
                  onChange={handleTabsChange}
                >
                  <Tabs.TabPane tab="Engagement Details " key="1">
                    <FrimDetailsTabs
                      productDtoList={productDtoName}
                      engagementDtoList={engagementDtoName}
                      roleDtoList={roleDtoName}
                      partnerPayoutDetails={partnerPayoutDetails}
                      props={props}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab=" Banking Info" key="2">
                    {bankDetails ? (
                      <BankDetailsTabs
                        getAll={getPartnerViewDetailsData}
                        bankDetails={bankDetails}
                        setShow={setShow}
                        showDrawer={showDrawer}
                      />
                    ) : (
                      "Details are not filled yet"
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab=" Branches" key="3">
                    {branchDtoList?.length > 0 ? (
                      <BranchDetailsTab
                        getAll={getPartnerViewDetailsData}
                        setShow={setShow}
                        showDrawer={showDrawer}
                        branchDtoList={branchDtoList}
                      />
                    ) : (
                      "Details are not filled yet"
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab=" Team Details" key="4">
                    {props?.editPartner?.PARTNER_TEAM_MASTER_DTO_LIST?.length >
                    0 ? (
                      <TeamDetailsTabs
                        setShow={setShow}
                        getAll={getPartnerViewDetailsData}
                        showDrawer={showDrawer}
                        teamDetails={
                          props?.editPartner.PARTNER_TEAM_MASTER_DTO_LIST
                        }
                      />
                    ) : (
                      "Details are not filled yet"
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Documents" key="5">
                    <ViewDocuments
                      Master={props?.documentMaster}
                      docs={props?.documents}
                    />
                  </Tabs.TabPane>

                  {(props?.state?.userData?.loggedInRoleType === "CET" ||
                    props?.state?.userData?.loggedInRoleType === "RM") &&
                    !(NewPartnerStatus || codeCreatedStatus) && (
                      <Tabs.TabPane tab="Verfication Info" key="6">
                        <RCUManager activeKey={activeKey} />
                      </Tabs.TabPane>
                    )}

                  {props?.state?.userData?.loggedInRoleType === "PARTNER" ||
                  props?.state?.userData?.loggedInRoleType === "POU" ||
                  NewPartnerStatus == true ||
                  codeCreatedStatus == true ? (
                    ""
                  ) : (
                    <Tabs.TabPane tab="E-Sign" key="7">
                      <ESign activeKey={activeKey} />
                    </Tabs.TabPane>
                  )}

                  {props?.state?.userData?.loggedInRoleType === "PARTNER" ||
                  props?.state?.userData?.loggedInRoleType === "POU" ||
                  NewPartnerStatus == true ? (
                    ""
                  ) : (
                    <Tabs.TabPane tab=" Business Branch Preferences" key="8">
                      {<BranchPreferences />}
                    </Tabs.TabPane>
                  )}
                </Tabs>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    engagementDetails: state?.engagementDetails?.engagementDetails,
    editPartner: state?.editPartner?.editPartner,
    EngagementMaster: state?.EngagementDetails,
    accessToken: state?.auth?.idToken,
    documents: state?.getDocuments,
    documentMaster: state?.documentsMaster,
    DocData: state?.PanDocs,
    progressData: state?.Progress?.progress,
    LogoutFlag: state.Logout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllEngagementDetails: (user) => dispatch(getAllEngagementDetails(user)),
    getPartnerViewDetails: (user) => dispatch(getPartnerViewDetails(user)),
    getAllDocuments: (user) => dispatch(getDocuments(user)),
    getData: (accessToken) => dispatch(EngagementDetailMaster(accessToken)),
    getPanDoc: (data) => dispatch(getPartnerPanDocuments(data)),
    getAllDocumentsMaster: (user) => dispatch(documentsMaster(user)),
    getProgress: (data) => dispatch(getProgress(data)),
    getESignDetails: (data) => dispatch(getESignDetails(data)),
    saveFirmPanDetails: (data) => dispatch(saveFirmPanDetails(data)),
    saveLeadActivation: (data) => dispatch(saveLeadActivation(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPartner);
